import { render, staticRenderFns } from "./SmsTemplate.vue?vue&type=template&id=67c59a04&"
import script from "./SmsTemplate.vue?vue&type=script&lang=js&"
export * from "./SmsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SmsTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports